<template>
  <div
    class="col-md-6"
    v-if="shouldShowInvitations"
  >
    <InvitationCard :person="person" />
  </div>
</template>

<script>
import InvitationCard from './InvitationCard.vue';

export default {
    name: 'InvitationCardWrapper',
    components: {
        InvitationCard
    },
    props: {
        person: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            canViewInvitations: null,
            invitationCheckCompleted: false,
        };
    },
    computed: {
        shouldShowInvitations() {
            return !this.loading
                && this.invitationCheckCompleted
                && this.canViewInvitations === true
                && this.person
                && this.person.id;
        }
    },
    watch: {
        person() {
            // Reset access when person changes
            this.canViewInvitations = null;
            this.invitationCheckCompleted = false;
            // Check invitation access when person data changes
            this.$nextTick(() => {
                this.checkInvitationAccess();
            });
        },
        shouldShowInvitations: {
            handler(newValue) {
                // Emit visibility change so parent can adjust layout
                this.$emit('visibility-changed', newValue);
            },
            immediate: true
        }
    },
    methods: {
        async checkInvitationAccess() {
            if (!this.person) {
                this.invitationCheckCompleted = true;
                return;
            }
            // If already checked (true or false), don't check again
            if (this.canViewInvitations !== null) {
                this.invitationCheckCompleted = true;
                return;
            }
            // If user is staff, they can view invitation data
            // eslint-disable-next-line
            const rolesWithAccess = ['missionary', 'td', 'pd', 'affiliate', 'rd', 'ad', 'chaplain', 'alumni', 'lifelong'];
            if (this.isOneOfTheseRoles(rolesWithAccess)) {
                this.canViewInvitations = true;
                this.invitationCheckCompleted = true;
                return;
            }
            // For students, check discipleship chain via API
            try {
                const response = await this.$http.post('/disciples/canViewPersonInChain', {
                    person_id: this.person.id
                });
                this.canViewInvitations = response.data.canView;
                this.invitationCheckCompleted = true;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error checking discipleship chain access:', error);
                this.canViewInvitations = false;
                this.invitationCheckCompleted = true;
            }
        }
    },
    created() {
        // Check invitation access when component is created
        this.$nextTick(() => {
            this.checkInvitationAccess();
        });
    }
};
</script>
